import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label: "Monofásica" },
    { value: 2, label: "Bifásica" },
    { value: 3, label: "Trifásica" }
];

const Fases = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { Fases, options as OpcoesFases }